import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  async getTrainingSystemsByOrganizationId() {
    try {
      const response = await axios.get('uni/trainingSystems/getByOrganizationId')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getCoursesByTrainingSystemId(params) {
    try {
      const response = await axios.get('uni/courses/getByTrainingSystemId', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getYears(params) {
    try {
      const response = await axios.get('uni/courses/getYearByCourseId', { params })
      const { data } = response
      return data.data
    } catch (e) {
      handleCatch(e)
    }
  },
  async getConvertCourseSemester(params) {
    try {
      const response = await axios.get('uni/course/semesters/getByCourseSemesterByCourseIdAndYearId', { params })
      const { data } = response
      return data.data
    } catch (e) {
      handleCatch(e)
    }
  },
  async getCourseSemesterByCourseIdAndYearId(params) {
    try {
      const response = await axios.get('uni/course/semesters/getByCourseIdAndYearId', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getReportConductPoint(params) {
    try {
      const response = await axios.get('uni/hluv/readConductPoint', { params })
      const { data } = response
      return data
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getClassByCourseId(params) {
    try {
      const response = await axios.get('uni/classes/getByCourseId', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
}
